<template>
  <div class="main jc-center">
    <div class="content">
      <div class="title">改变从这里开始</div>
      <div class="flex">
        <el-input
          v-model="form.name"
          placeholder="请输入您的称呼"
          class="name"
        ></el-input>
        <el-input
          v-model="form.mobile"
          placeholder="请输入您的联系方式"
          class="mobile"
        ></el-input>
        <el-select
          v-model="form.course"
          placeholder="请选择您的咨询课程"
          class="course"
        >
          <el-option
            v-for="item in options"
            :key="item"
            :label="item"
            :value="item"
          >
          </el-option>
        </el-select>
        <div class="btn">点击提交</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      options: ["初级会计", "二级建造", "教师资格"],
      form: { course: "", name: "", course: "" },
    };
  },
};
</script>
<style lang="less" scoped>
.main {
  object-fit: cover;
  height: 180px;
  background: url("http://68wx--test.oss-cn-hangzhou.aliyuncs.com/tkwx/16542203722307618064388.jpg")
    no-repeat;
  background-size: 100%;
  .content {
    width: 1200px;
    .title {
      text-align: center;
      margin-bottom: 20px;
      font-size: 24px;
      color: #fff;
    }
    .name,
    .mobile {
      width: 350px;
      margin-right: 8px;
    }
    .course {
      width: 370px;
      margin-right: 8px;
    }
    .btn {
      line-height: 38px;
      text-align: center;
      width: 90px;
      height: 38px;
      color: #fff;
      background-color: #0d6efd;
      border-color: #0d6efd;
      border-radius: 6px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/designPage/template/other/other1/index.vue